export class ApiName {
  readonly #value: string;

  private constructor(value: string) {
    this.#value = value;
  }

  static of(value: ApiName | string): ApiName {
    if (value instanceof ApiName) {
      return value;
    }
    return new ApiName(value);
  }

  get value(): string {
    return this.#value;
  }
}
